import { ITaskDenormalized } from '@dadohr/shared/domainTypes/experience';
import { PAEventType } from '@dadohr/shared/domainTypes/productAnalytics';
import { useState } from 'react';
import { useUnsafeTranslation } from '../../../../../../i18next';
import { FlexContainerVertical } from '../../../../../../layout/Flex';
import { useProductAnalytics } from '../../../../../features/Experience/services/productAnalytics';
import { CollapsibleSubHeader } from '../CollapsibleSubHeader';
import { EmployeeAppCard } from '../EmployeeAppCard';
import { TaskLink, TaskWithStatusAndCompletionOrDueDate } from '../Tasks';

export const CompletedSection = ({
  completedTasks,
  actorAccessToken,
  instanceAccessToken,
  areThereAnyIncompleteTasks,
  returnTo
}: {
  completedTasks: ITaskDenormalized[];
  actorAccessToken: string;
  instanceAccessToken: string;
  areThereAnyIncompleteTasks: boolean;
  returnTo?: string;
}) => {
  const { trackEvent } = useProductAnalytics(instanceAccessToken);
  const [expanded, setExpanded] = useState(!areThereAnyIncompleteTasks);
  const { t } = useUnsafeTranslation();
  if (!completedTasks.length) {
    return null;
  }
  return (
    <FlexContainerVertical fullWidth spacing={2}>
      <CollapsibleSubHeader
        title={t('Completed tasks')}
        expanded={expanded}
        toggle={() => {
          if (!expanded) {
            trackEvent({
              eventType: PAEventType.EMPLOYEE_EXPERIENCE_INSTANCE,
              name: 'Completed Tasks Expanded',
              Explanation: 'User expanded the completed tasks section'
            });
          }
          setExpanded((x) => !x);
        }}
      />
      {expanded &&
        completedTasks.map((tsk) => (
          <EmployeeAppCard key={tsk.id} hoverEffect>
            <TaskLink
              actorAccessToken={actorAccessToken}
              instanceAccessToken={instanceAccessToken}
              taskId={tsk.id}
              returnTo={returnTo}
            >
              <TaskWithStatusAndCompletionOrDueDate d={tsk} />
            </TaskLink>
          </EmployeeAppCard>
        ))}
    </FlexContainerVertical>
  );
};
